import { render } from "./SingleChoiceQuestionItem.vue?vue&type=template&id=30fa352e&ts=true"
import script from "./SingleChoiceQuestionItem.vue?vue&type=script&lang=ts"
export * from "./SingleChoiceQuestionItem.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__